import { Box, Button, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import ChangePasswordImage from "@/assets/lotties/admin-profile/changePasswordGIF.json";
import Flex from "@/components/Flex";
import Lottie from "@/components/Lottie";
import SideSheetDrawer from "@/components/SidesheetDrawer";
import PasswordInput from "@/components/app/PasswordInput";
import {
  CHANGE_PASSWORD_FORM_INITIAL_VALUES,
  ChangePasswordFormType,
} from "@/constants/setting-initial-values";
import { useSnackbar } from "@/hooks/useSnackbar";
import { useChangePassword } from "@/queries/use-change-password";
import { getErrorSnackbar, getSuccessSnackbar } from "@/utils/utils";

interface ChangePassWordProps {
  open: boolean;
  onClose: () => void;
}

const changePasswordValidationSchema = Yup.object({
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required()
    .label("New Password"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), ""], "Passwords must match")
    .required()
    .label("Confirm Password"),
});

const ChangePasswordDrawer = ({ open, onClose }: ChangePassWordProps) => {
  const {
    values,
    handleBlur,
    touched,
    errors,
    handleSubmit,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: CHANGE_PASSWORD_FORM_INITIAL_VALUES,
    validationSchema: changePasswordValidationSchema,
    onSubmit,
  });
  const { mutateAsync: changePassword } = useChangePassword();
  const showSnackbar = useSnackbar();

  function onSubmit(values: ChangePasswordFormType) {
    return changePassword({
      currentPassword: "",
      newPassword: values.newPassword.trim(),
    })
      .then((res) => {
        showSnackbar(getSuccessSnackbar(res));

        resetForm();
        onClose();
      })
      .catch((err) => {
        showSnackbar(getErrorSnackbar(err));
      });
  }

  return (
    <SideSheetDrawer
      open={open}
      onClose={() => {
        resetForm();
        onClose();
      }}
      title="Change Password"
      w="884px"
      footerActions={
        <Button
          onClick={() => handleSubmit()}
          variant="contained"
          sx={{ width: "158px" }}
        >
          Update Password
        </Button>
      }
    >
      <Flex flexDirection={"column"} gap={"18px"}>
        <Flex justifyContent={"center"} alignItems={"center"}>
          <Box width={"275px"} height={"275px"}>
            <Lottie animationData={ChangePasswordImage} />
          </Box>
        </Flex>
        <Grid container spacing={2.5} direction={"column"}>
          {/* <Grid item xs={12}>
            <Input
              label="Current password"
              textFieldProps={{
                name: "currentPassword",
                type: "password",
                value: values.currentPassword,
                onChange: handleChange,
                onBlur: handleBlur,
                placeholder: "*********",
              }}
              required={true}
              error={
                touched.currentPassword ? errors.currentPassword : undefined
              }
            />
          </Grid> */}
          <Grid item xs={12}>
            <PasswordInput
              name="newPassword"
              onBlur={handleBlur}
              label={"New password"}
              value={values.newPassword}
              onChange={(value) => {
                setFieldValue("newPassword", value);
              }}
              required
              error={touched.newPassword && (errors.newPassword as any)}
            />
          </Grid>
          <Grid item xs={12}>
            <PasswordInput
              label={"Confirm new password"}
              name="confirmPassword"
              onBlur={handleBlur}
              value={values.confirmPassword}
              onChange={(value) => {
                setFieldValue("confirmPassword", value);
              }}
              required
              error={(touched.confirmPassword && errors.confirmPassword) as any}
            />
          </Grid>
        </Grid>
      </Flex>
    </SideSheetDrawer>
  );
};

export default ChangePasswordDrawer;
